export default "__VITE_ASSET__1fe61521__"